export default function isDefined(value) {
    return value !== null && value !== undefined;
}
